import { resolveStatusProntuario } from 'components/core/StatusProntuarioBadge';
import useIsMobile from 'hooks/useIsMobile';
import { useState } from 'react';
import { Badge, Button, Card } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp, FaLock, FaLockOpen, FaPencilAlt } from 'react-icons/fa';
import PopupMenu from './PopupMenu';

const LOCK_ICON_CONFIG = {
  DEFINITIVO: { Icon: FaLock, title: 'Prontuário Gravado Definitivamente' },
  PARCIAL: { Icon: FaLockOpen, title: 'Prontuário Parcial (rascunho)' },
  RASCUNHO: { Icon: FaPencilAlt, title: 'Em preenchimento — não salvo' },
};

function LockIcon({ status }) {
  const { Icon, title } = LOCK_ICON_CONFIG[status] || LOCK_ICON_CONFIG.RASCUNHO;
  return (
    <Icon size={18} title={title} style={{ flexShrink: 0, opacity: 0.95 }} aria-label={title} />
  );
}

export default function Sidebar({
  prontuarios = [],
  setProntuarios,
  prontuario,
  setProntuario,
  isDisabled,
  onSolicitarCopia,
}) {
  const [showAll, setShowAll] = useState(false);
  const isMobile = useIsMobile();

  const getButtonColor = (p) => {
    const tipo = p?.TIPO?.trim();
    if (tipo === 'SEC') {
      return {
        bg: '#fff5f5',
        border: '#dc3545',
        text: '#dc3545',
        label: p.dataFormatada,
        badgeVariant: 'danger',
      };
    }
    if (tipo === 'PCP') {
      return {
        bg: '#f0f7ff',
        border: '#0d6efd',
        text: '#0d6efd',
        label: p.dataFormatada,
        badgeVariant: 'primary',
      };
    }
    if (tipo === 'ORT') {
      return {
        bg: '#f0f7ff',
        border: '#b10dfd',
        text: '#b10dfd',
        label: p.dataFormatada,
        badgeVariant: null,
      };
    }
    return {
      bg: '#f0fff4',
      border: '#198754',
      text: '#198754',
      label: p.dataFormatada,
      badgeVariant: 'success',
    };
  };

  // Define o limite baseado no dispositivo (5 para Mobile, 10 para Desktop)
  const limit = isMobile ? 5 : 10;

  // Aplica o corte dinâmico se a lista não estiver expandida
  const prontuariosExibidos = showAll ? prontuarios : prontuarios.slice(0, limit);

  // Verifica se a quantidade total de itens é maior do que o limite do dispositivo atual
  const possuiMaisItens = prontuarios.length > limit;

  return (
    <div className="rounded border bg-light" style={{ padding: '0.25rem' }}>
      {prontuariosExibidos.map((p) => {
        const colors = getButtonColor(p);
        const isActive = prontuario?.CODCONSULTA === p.CODCONSULTA;
        const cardBgColor = isActive ? colors.bg : '#ffffff';

        return (
          <Card
            className="mb-2"
            key={p.CODCONSULTA}
            style={{
              cursor: 'pointer',
              border: `2px solid ${isActive ? colors.border : '#e0e0e0'}`,
              backgroundColor: cardBgColor,
              '--bs-card-bg': cardBgColor,
            }}
          >
            <Card.Body className="p-1 d-flex align-items-center" onClick={() => setProntuario(p)}>
              <Badge
                bg={colors.badgeVariant || null}
                className={`d-flex align-items-center gap-1 font-weight-bold px-3 py-2 rounded ${
                  colors.badgeVariant == null ? 'text-white' : ''
                }`}
                style={colors.badgeVariant == null ? { backgroundColor: colors.border } : undefined}
              >
                <LockIcon status={resolveStatusProntuario(p)} />
                <span className="text-truncate font-weight-bold mb-0 h6">{colors.label}</span>
              </Badge>

              <div style={{ marginLeft: 'auto' }} onClick={(e) => e.stopPropagation()}>
                <PopupMenu
                  prontuario={p}
                  prontuarioAtual={prontuario}
                  prontuarios={prontuarios}
                  setProntuario={setProntuario}
                  setProntuarios={setProntuarios}
                  onClick={() => setProntuario(p)}
                  isDisabled={isDisabled}
                  onSolicitarCopia={onSolicitarCopia}
                />
              </div>
            </Card.Body>
          </Card>
        );
      })}

      {/* Botão de Controle "Ver Mais / Ver Menos" ativado para Mobile e Desktop */}
      {possuiMaisItens && (
        <div className="p-1 text-center">
          <Button
            variant="outline-secondary"
            size="sm"
            className="w-100 d-flex align-items-center justify-content-center gap-1"
            onClick={() => setShowAll((prev) => !prev)}
            style={{ fontSize: '0.8rem' }}
          >
            {showAll ? (
              <>
                Exibir menos <FaChevronUp size={12} />
              </>
            ) : (
              <>
                Ver todas ({prontuarios.length}) <FaChevronDown size={12} />
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
